import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NzAlertModule } from 'ng-zorro-antd/alert';

import { ReasonDetail } from '../../../model';
import { severityToNzType } from './failure-reason-messages';

@Component({
  selector: 'app-failure-reason',
  templateUrl: './failure-reason.component.html',
  styleUrls: ['./failure-reason.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzAlertModule, DecimalPipe],
})
export class FailureReasonComponent {
  @Input()
  reasons: ReasonDetail[] | undefined;

  protected nzType(severity: ReasonDetail['severity']): 'success' | 'info' | 'warning' | 'error' {
    return severityToNzType(severity);
  }
}
